import { useEffect } from "react";
import { Outlet, useLocation, useParams } from "react-router";

import { Footer } from "@/components/layout/Footer";
import { Header } from "@/components/layout/Header";
import { DEFAULT_LOCALE, LocaleProvider, isLocale, useLocale } from "@/i18n";
import { isPlatformConfigured } from "@/lib/platform-url";

/**
 * Development-only notice. If a build has no platform URL configured the CTAs
 * would silently go nowhere; saying so out loud is better than a dead button.
 * Never rendered in production builds.
 */
function PlatformNotice() {
  const { t } = useLocale();
  if (import.meta.env.PROD || isPlatformConfigured) return null;

  return (
    <div
      role="status"
      className="border-b border-lavender-400/25 bg-lavender-500/10 px-4 py-2.5 text-center text-sm text-lavender-200"
    >
      <strong className="font-medium">{t.platformNotice.title}</strong>{" "}
      <span className="text-lavender-200/80">{t.platformNotice.body}</span>
    </div>
  );
}

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);
  return null;
}

export function SiteLayout() {
  const { locale: param } = useParams();
  const locale = isLocale(param) ? param : DEFAULT_LOCALE;

  return (
    <LocaleProvider locale={locale}>
      <ScrollToTop />
      <div className="flex min-h-dvh flex-col bg-ink-950">
        <PlatformNotice />
        <Header />
        <main id="main" className="flex-1">
          <Outlet />
        </main>
        <Footer />
      </div>
    </LocaleProvider>
  );
}
